<template>
  <div class="content" v-if="rendered">
    <div class="row text-left">
      <div class="col-lg-3 col-md-6">
        <drop-down tag="div">
          <button
            aria-label="Settings menu"
            data-toggle="dropdown"
            class="dropdown-toggle btn btn-primary"
          >
            {{
              restauranteEscolhido != ""
                ? restauranteEscolhido
                : "Escolher Restaurante"
            }}
          </button>
          <ul class="dropdown-menu">
            <span
              class="dropdown-item pointer"
              @click="mudarRestaurante('Todos')"
              >Todos</span
            >
            <span
              v-for="(rest, i) in todosRestaurantes"
              :key="i"
              class="dropdown-item pointer"
              @click="mudarRestaurante(rest.nome)"
              >{{ rest.nome }}</span
            >
          </ul>
        </drop-down>
      </div>
    </div>

    <div class="row customizar">
      <div class="row text-left">
        <div class="col-lg-2 col-md-2">
          <base-button
            @click="filtragem = !filtragem"
            native-type="submit"
            type="primary"
            size="sm"
            block
          >
            Customizar Datas
          </base-button>
        </div>
      </div>
      <div class="row text-left mt-3" v-if="filtragem">
        <div class="col-lg-4">
          <base-input>
            <el-date-picker
              type="daterange"
              range-separator="a"
              start-placeholder="Data início"
              end-placeholder="Data fim"
              v-model="dateRange"
              class="transparent"
              @change="onDateChange"
            >
            </el-date-picker>
          </base-input>
        </div>
      </div>
    </div>
    <div class="row mt-3">
      <div class="col-lg-3 col-md-6" v-for="(card, i) in statsCards" :key="i">
        <stats-card
          :title="card.title"
          :sub-title="card.subTitle"
          :type="card.type"
          :icon="card.icon"
        >
          <div slot="footer" v-html="card.footer"></div>
        </stats-card>
      </div>
    </div>
    <div class="row">
      <div class="col-lg-4">
        <card type="chart" cardCol>
          <template slot="header">
            <h5 class="card-category text-left">
              Top Bebidas
            </h5>
            <h3 class="card-title text-left">
              <i class="fas fa-glass-martini" style="color:#243024"></i>
            </h3>
          </template>
          <bar-chart
            class="chart-area"
            chart-id="blue-bar-chart"
            :chart-data="bebidasChart.chartData"
            :gradient-stops="bebidasChart.gradientStops"
            :extra-options="bebidasChart.extraOptions"
          >
          </bar-chart>
        </card>
      </div>
      <div class="col-lg-4">
        <card type="chart" cardCol>
          <template slot="header">
            <h5 class="card-category text-left">
              Top Prato
            </h5>
            <h3 class="card-title text-left">
              <i class="fas fa-utensils " style="color:#243024"></i>
            </h3>
          </template>
          <bar-chart
            class="chart-area"
            chart-id="blue-bar-chart"
            :chart-data="pratosChart.chartData"
            :gradient-stops="pratosChart.gradientStops"
            :extra-options="pratosChart.extraOptions"
          >
          </bar-chart>
        </card>
      </div>
      <div class="col-lg-4">
        <card type="chart" cardCol>
          <template slot="header">
            <h5 class="card-category text-left">
              Visitas
            </h5>
            <h3 class="card-title text-left">
              <i class="tim-icons icon-delivery-fast" style="color:#243024"></i>
            </h3>
          </template>
          <line-chart
            class="chart-area"
            chart-id="purple-line-chart"
            :chart-data="visitasChart.chartData"
            :gradient-stops="visitasChart.gradientStops"
            :extra-options="visitasChart.extraOptions"
          >
          </line-chart>
        </card>
      </div>
    </div>
    <div class="row">
      <div class="col-lg-4">
        <card type="chart" cardCol>
          <template slot="header">
            <h5 class="card-category text-left">
              Visitas Únicas
            </h5>
            <h3 class="card-title text-left">
              <i class="tim-icons icon-delivery-fast" style="color:#243024"></i>
            </h3>
          </template>
          <line-chart
            class="chart-area"
            chart-id="purple-line-chart"
            :chart-data="visitasUnicasChart.chartData"
            :gradient-stops="visitasUnicasChart.gradientStops"
            :extra-options="visitasUnicasChart.extraOptions"
          >
          </line-chart>
        </card>
      </div>
      <div class="col-lg-4">
        <card type="chart" cardCol>
          <template slot="header">
            <h5 class="card-category text-left">
              Faturação €
            </h5>
            <h3 class="card-title text-left">
              <i class="tim-icons icon-coins" style="color:#243024"></i>
            </h3>
          </template>
          <line-chart
            class="chart-area"
            chart-id="purple-line-chart"
            :chart-data="faturacaoLineChart.chartData"
            :gradient-stops="faturacaoLineChart.gradientStops"
            :extra-options="faturacaoLineChart.extraOptions"
          >
          </line-chart>
        </card>
      </div>

      <div class="col-lg-4">
        <card type="chart" cardCol>
          <template slot="header">
            <h5 class="card-category text-left">
              Ticket Médio / Mês €
            </h5>
            <h3 class="card-title text-left">
              <i class="tim-icons icon-coins" style="color:#243024"></i>
            </h3>
          </template>
          <line-chart
            class="chart-area"
            chart-id="purple-line-chart"
            :chart-data="ticketMedioChart.chartData"
            :gradient-stops="ticketMedioChart.gradientStops"
            :extra-options="ticketMedioChart.extraOptions"
          >
          </line-chart>
        </card>
      </div>
    </div>
    <div class="row">
      <div class="col-lg-12 col-md-12">
        <card class="card">
          <div class="row text-left space-between">
            <div class="col-lg-3 col-md-6">
              <drop-down tag="div">
                <button
                  aria-label="Settings menu"
                  data-toggle="dropdown"
                  class="dropdown-toggle btn btn-primary"
                >
                  Top {{ topEscolhido == -1 ? "" : topEscolhido }} clientes
                </button>
                <ul class="dropdown-menu">
                  <span @click="mudarTop(3)" class="dropdown-item pointer"
                    >3</span
                  >
                  <span @click="mudarTop(5)" class="dropdown-item pointer"
                    >5</span
                  >
                  <span @click="mudarTop(10)" class="dropdown-item pointer"
                    >10</span
                  >
                  <span @click="mudarTop(15)" class="dropdown-item pointer"
                    >15</span
                  >
                  <span @click="mudarTop(20)" class="dropdown-item pointer"
                    >20</span
                  >
                  <span @click="mudarTop(-1)" class="dropdown-item pointer"
                    >Tudo</span
                  >
                </ul>
              </drop-down>
            </div>
            <div class="col-lg-2 col-md-2 pl-0">
              <base-button
                @click="exportToXlsx"
                native-type="submit"
                type="primary"
                size="sm"
                block
              >
                Exportar dados de consumo
              </base-button>
            </div>
          </div>
          <h5 slot="header" class="card-title text-left">
            <template>
              <p style="font-size:18px; font-weight: bold;">
                TOP {{ topEscolhido == -1 ? "" : topEscolhido }} clientes
                <span
                  class="descricaoTable"
                  style="font-size:12px; font-weight: 400;"
                >
                  {{
                    "(De " +
                      formatDatePT(periodoCustomizado[0].data_inicio) +
                      " a " +
                      formatDatePT(periodoCustomizado[0].data_fim) +
                      " )"
                  }}</span
                >
              </p>
            </template>
          </h5>
          <div class="table-responsive">
            <base-table :data="table" thead-classes="text-primary">
              <template slot="columns">
                <th class="text-left">Nome</th>
                <th class="text-left">NIF</th>
                <th class="text-left">Telefone</th>
                <th class="text-left">Email</th>
                <th class="text-left">Top Bebida</th>
                <th class="text-left">Top Prato</th>
                <th class="text-left">Total Gasto</th>
                <th class="text-left">Ações</th>
              </template>

              <template slot-scope="{ row, index }">
                <td class="text-left">{{ row.nome }}</td>
                <td class="text-left">{{ row.NIF }}</td>
                <td class="text-left">
                  {{ row.telefone }}
                </td>
                <td class="text-left">{{ row.email }}</td>
                <td class="text-left">{{ row.top_bebida }}</td>
                <td class="text-left">{{ row.top_prato }}</td>
                <td class="text-left">
                  {{ row.total_gasto }} € ({{ percentagem(row.total_gasto) }} %)
                </td>
                <td class="text-left">
                  <el-tooltip
                    content="Ver mais"
                    effect="light"
                    :open-delay="300"
                    placement="top"
                  >
                    <base-button
                      :type="index > 2 ? 'success' : 'neutral'"
                      icon
                      size="sm"
                      class="btn-link"
                      @click="carregarInfoCliente(row.qr_code, row.nome)"
                    >
                      <i class="tim-icons icon-badge"></i>
                    </base-button>
                  </el-tooltip>
                </td>
              </template>
            </base-table>
          </div>
        </card>
        <div class="row text-left">
          <div class="col-6">
            <card>
              <i class="tim-icons  icon-tag text-warning"></i> % Visitas Top
              {{ topEscolhido == -1 ? "" : topEscolhido }} clientes
              <div class="chart-area">
                <pie-chart
                  :chart-data="pieChart3.chartData"
                  :extra-options="pieChart3.extraOptions"
                  :height="200"
                >
                </pie-chart>
              </div>
            </card>
          </div>
          <div class="col-6">
            <card>
              <i class="tim-icons  icon-tag text-warning"></i> % Faturação Top
              {{ topEscolhido == -1 ? "" : topEscolhido }} clientes
              <div class="chart-area">
                <pie-chart
                  :chart-data="pieChart2.chartData"
                  :extra-options="pieChart2.extraOptions"
                  :height="200"
                >
                </pie-chart>
              </div>
            </card>
          </div>
        </div>
      </div>
    </div>
    <modal :show.sync="modals.classic" headerClasses="justify-content-center">
      <h4 slot="header" class="title title-up">
        {{ selectedClientPurchases.nome }}
      </h4>
      <div class="row text-left">
        <h4>Histórico de compras</h4>
      </div>
      <div class="col-6" style="padding-left:0px">
        <base-input
          name="pesquisa"
          v-model="searchQuery"
          type="text"
          placeholder="Pesquisa"
          addon-left-icon="tim-icons icon-zoom-split"
        >
        </base-input>
      </div>
      <el-table :data="filteredPurchases">
        <el-table-column
          min-width="150"
          sortable
          label="Produto"
          property="produto"
        ></el-table-column>
        <el-table-column
          min-width="150"
          sortable
          label="Quantidade"
          property="quantidade"
        ></el-table-column>
        <el-table-column
          min-width="150"
          sortable
          label="Tipo"
          property="categoria"
        ></el-table-column>
      </el-table>
    </modal>
  </div>
  <div v-else>
    <div class="loading-overlay">
      <span class="fas fa-spinner fa-3x fa-spin"></span>
    </div>
  </div>
</template>
<script>
import { Card, DropDown, Modal, BaseInput } from "@/components/index";
import LineChart from "@/components/Charts/LineChart";
import BarChart from "@/components/Charts/BarChart";
import * as chartConfigs from "@/components/Charts/config";
import TaskList from "./Dashboard/TaskList";
import config from "@/config";
import StatsCard from "@/components/Cards/StatsCard";
import api from "../api/index";
import { BaseTable, BaseProgress } from "@/components";
import { Table, TableColumn, DatePicker } from "element-ui";
import PieChart from "@/components/Charts/PieChart";
import Papa from "papaparse";
import * as XLSX from "xlsx";
export default {
  components: {
    Card,
    StatsCard,
    LineChart,
    BarChart,
    BaseInput,
    TaskList,
    Modal,
    BaseTable,
    BaseProgress,
    PieChart,
    // eslint-disable-next-line vue/no-unused-components
    [Table.name]: Table,
    // eslint-disable-next-line vue/no-unused-components
    [TableColumn.name]: TableColumn,
  },
  data() {
    return {
      rendered: false,
      restauranteEscolhido: "",
      searchQuery: "",
      filtragem: false,
      todosRestaurantes: [],
      statsCards: [
        {
          title: "",
          subTitle: "Top bebida",
          type: "warning",
          icon: "fas fa-glass-martini",
          footer: "<strong>Desde que se registou</strong>",
        },
        {
          title: "",
          subTitle: "Top Prato",
          type: "primary",
          icon: "fas fa-utensils",
          footer: "<strong>Desde que se registou</strong>",
        },
        {
          title: "0",
          subTitle: "Número de visitas",
          type: "info",
          icon: "tim-icons icon-delivery-fast",
          footer: "<strong>Dos últimos 6 meses</strong>",
        },
        {
          title: "0",
          subTitle: "Ticket médio",
          type: "danger",
          icon: "tim-icons icon-molecule-40",
          footer:
            "<strong>Dos últimos " + this.periodo_meses + " meses</strong>",
        },
      ],
      table: [],
      dateRange: [],
      bebidasChart: {},
      pratosChart: {},
      topEscolhido: 2,
      visitasUnicasChart: {
        extraOptions: chartConfigs.purpleChartOptions,
        chartData: {
          labels: ["JUL", "AUG", "SEP", "OCT", "NOV"],
          datasets: [
            {
              label: "My First dataset",
              fill: true,
              borderColor: config.colors.danger,
              borderWidth: 2,
              borderDash: [],
              borderDashOffset: 0.0,
              pointBackgroundColor: config.colors.danger,
              pointBorderColor: "rgba(255,255,255,0)",
              pointHoverBackgroundColor: config.colors.danger,
              pointBorderWidth: 20,
              pointHoverRadius: 4,
              pointHoverBorderWidth: 15,
              pointRadius: 4,
              data: [90, 27, 60, 12, 80],
            },
          ],
        },
        gradientColors: [
          "rgba(255, 99, 71, 0.5)",
          "rgba(255, 99, 71, 0.5)",
          "rgba(255, 99, 71, 0.5)",
        ],
        gradientStops: [1, 0.4, 0],
      },
      faturacaoLineChart: {
        extraOptions: chartConfigs.purpleChartOptions,
        chartData: {
          labels: ["JUL", "AUG", "SEP", "OCT", "NOV"],
          datasets: [
            {
              label: "My First dataset",
              fill: true,
              borderColor: config.colors.danger,
              borderWidth: 2,
              borderDash: [],
              borderDashOffset: 0.0,
              pointBackgroundColor: config.colors.danger,
              pointBorderColor: "rgba(255,255,255,0)",
              pointHoverBackgroundColor: config.colors.danger,
              pointBorderWidth: 20,
              pointHoverRadius: 4,
              pointHoverBorderWidth: 15,
              pointRadius: 4,
              data: [90, 27, 60, 12, 80],
            },
          ],
        },
        gradientColors: [
          "rgba(66,134,121,0.15)",
          "rgba(66,134,121,0.0)",
          "rgba(66,134,121,0)",
        ],
        gradientStops: [1, 0.4, 0],
      },
      ticketMedioChart: {
        extraOptions: chartConfigs.purpleChartOptions,
        chartData: {
          labels: ["JUL", "AUG", "SEP", "OCT", "NOV"],
          datasets: [
            {
              label: "My First dataset",
              fill: true,
              borderColor: config.colors.danger,
              borderWidth: 2,
              borderDash: [],
              borderDashOffset: 0.0,
              pointBackgroundColor: config.colors.danger,
              pointBorderColor: "rgba(255,255,255,0)",
              pointHoverBackgroundColor: config.colors.danger,
              pointBorderWidth: 20,
              pointHoverRadius: 4,
              pointHoverBorderWidth: 15,
              pointRadius: 4,
              data: [90, 27, 60, 12, 80],
            },
          ],
        },
        gradientColors: [
          "rgba(66,134,121,0.15)",
          "rgba(66,134,121,0.0)",
          "rgba(66,134,121,0)",
        ],
        gradientStops: [1, 0.4, 0],
      },
      visitasChart: {
        extraOptions: chartConfigs.purpleChartOptions,
        chartData: {
          labels: ["JUL", "AUG", "SEP", "OCT", "NOV"],
          datasets: [
            {
              label: "My First dataset",
              fill: true,
              borderColor: config.colors.danger,
              borderWidth: 2,
              borderDash: [],
              borderDashOffset: 0.0,
              pointBackgroundColor: config.colors.danger,
              pointBorderColor: "rgba(255,255,255,0)",
              pointHoverBackgroundColor: config.colors.danger,
              pointBorderWidth: 20,
              pointHoverRadius: 4,
              pointHoverBorderWidth: 15,
              pointRadius: 4,
              data: [90, 27, 60, 12, 80],
            },
          ],
        },
        gradientColors: [
          "rgba(66,134,121,0.15)",
          "rgba(66,134,121,0.0)",
          "rgba(66,134,121,0)",
        ],
        gradientStops: [1, 0.4, 0],
      },
      faturacao: 0,
      consumo: [],
      selectedClientPurchases: {
        nome: "",
        compras: [],
      },
      restaurante: "",
      periodo_meses: 6,
      modals: {
        classic: false,
      },

      pieChart2: {
        chartData: {},
        extraOptions: chartConfigs.pieChartOptions,
      },
      pieChart3: {
        chartData: {},
        extraOptions: chartConfigs.pieChartOptions,
      },
      periodoCustomizado: [
        {
          data_inicio: "",
          data_fim: "",
        },
      ],
    };
  },
  computed: {
    enableRTL() {
      return this.$route.query.enableRTL;
    },

    isRTL() {
      return this.$rtl.isRTL;
    },

    filteredPurchases() {
      // Filtra as compras com base no valor da busca
      return this.selectedClientPurchases.compras.filter((compra) => {
        return compra.produto
          .toLowerCase()
          .includes(this.searchQuery.toLowerCase());
      });
    },
  },
  methods: {
    exportToXlsx() {
      var temp = this.table;
      temp.forEach((cliente) => {
        const comprasDoCliente = this.consumo.filter(
          (item) => item.qr_code === cliente.qr_code
        );
        const productDetails = {};

        comprasDoCliente.forEach((item) => {
          const productName = item.produto;
          const quantity = parseInt(item.quantidade, 10);
          const categoria = this.capitalizeFirstLetter(item.categoria) || "N/A";

          if (productDetails[productName]) {
            productDetails[productName].quantidade += quantity;
            if (
              this.capitalizeFirstLetter(
                productDetails[productName].categoria
              ) !== categoria
            ) {
              productDetails[productName].categoria = categoria;
            }
          } else {
            productDetails[productName] = {
              quantidade: quantity,
              categoria: categoria,
            };
          }
        });

        const uniqueProducts = Object.keys(productDetails).map(
          (productName) => ({
            produto: productName,
            quantidade: productDetails[productName].quantidade,
            categoria: this.capitalizeFirstLetter(
              productDetails[productName].categoria
            ),
          })
        );

        uniqueProducts.sort((a, b) => b.quantidade - a.quantidade);

        // Adiciona os produtos ao cliente
        cliente.produtos = uniqueProducts;
      });

      const linhasExcel = [];

      temp.forEach((cliente) => {
        cliente.produtos.forEach((prod) => {
          linhasExcel.push({
            nome: cliente.nome,
            NIF: cliente.NIF,
            email: cliente.email,
            telefone: cliente.telefone,
            sexo: cliente.sexo,
            data_nascimento: cliente.data_nascimento,
            produto: prod.produto,
            quantidade: prod.quantidade,
            categoria: prod.categoria,
            top_bebida: cliente.top_bebida,
            top_prato: cliente.top_prato,
            total_gasto: cliente.total_gasto,
            qr_code: cliente.qr_code,
          });
        });
      });
      const worksheet = XLSX.utils.json_to_sheet(linhasExcel);
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, "Relatório");
      XLSX.writeFile(workbook, "Relatório Consumo.xlsx");
    },
    percentagem(valor) {
      return ((Number(valor) * 100) / this.faturacao).toFixed(2);
    },
    carregarInfoCliente(qr_code, nome) {
      this.selectedClientPurchases.compras = this.consumo.filter(
        (item) => item.qr_code === qr_code
      );
      this.selectedClientPurchases.nome = nome;
      const productDetails = {};

      this.selectedClientPurchases.compras.forEach((item) => {
        const productName = item.produto;
        const quantity = parseInt(item.quantidade, 10);
        const categoria = this.capitalizeFirstLetter(item.categoria) || "N/A";

        if (productDetails[productName]) {
          productDetails[productName].quantidade += quantity;
          if (
            this.capitalizeFirstLetter(productDetails[productName].categoria) !=
            categoria
          ) {
            productDetails[productName].categoria = categoria;
          }
        } else {
          productDetails[productName] = {
            quantidade: quantity,
            categoria: categoria,
          };
        }
      });

      const uniqueProducts = Object.keys(productDetails).map((productName) => ({
        produto: productName,
        quantidade: productDetails[productName].quantidade,
        categoria: this.capitalizeFirstLetter(
          productDetails[productName].categoria
        ),
      }));
      uniqueProducts.sort((a, b) => b.quantidade - a.quantidade);
      this.modals.classic = true;
      this.selectedClientPurchases.compras = uniqueProducts;
    },

    mudarPeriodo(periodo) {
      this.periodo_meses = periodo;
      localStorage.setItem("gerenciaPeriodoMeses", periodo);
      this.inicio();
    },
    mudarTop(top) {
      this.topEscolhido = top;
      localStorage.setItem("gerenciaTopEscolhido", top);
      this.inicio();
    },

    capitalizeFirstLetter(text) {
      if (!text) return text;
      return text.charAt(0).toUpperCase() + text.slice(1);
    },
    formatDateToYMD(date) {
      const ano = date.getFullYear();
      const mes = String(date.getMonth() + 1).padStart(2, "0");
      const dia = String(date.getDate()).padStart(2, "0");
      return `${ano}-${mes}-${dia}`;
    },
    limparFiltros() {
      // período padrão: últimos 12 meses
      const hoje = new Date();
      const fim = hoje.toISOString().split("T")[0];
      const inicio = new Date(hoje.setMonth(hoje.getMonth() - 12))
        .toISOString()
        .split("T")[0];

      this.periodoCustomizado = [
        {
          data_inicio: inicio,
          data_fim: fim,
        },
      ];

      sessionStorage.removeItem(
        "periodoCustomizado",
        JSON.stringify(this.periodoCustomizado)
      );

      this.inicio();
    },
    onDateChange(val) {
      if (val && val.length === 2) {
        const startDate = new Date(val[0]);
        const endDate = new Date(val[1]);
        endDate.setHours(23, 59, 59, 999);

        this.dateRange = [startDate, endDate];

        const data_inicio = this.formatDateToYMD(startDate);
        const data_fim = this.formatDateToYMD(endDate);

        this.periodoCustomizado = [
          {
            data_inicio: data_inicio,
            data_fim: data_fim,
          },
        ];

        sessionStorage.setItem(
          "periodoCustomizado",
          JSON.stringify(this.periodoCustomizado)
        );
        this.inicio();
      } else {
        this.limparFiltros();
      }
    },

    mudarRestaurante(restaurante) {
      localStorage.setItem("gerenciaRestauranteAtivo", restaurante);
      this.restauranteEscolhido = restaurante;
      this.inicio();
    },
    async inicio() {
      this.rendered = false;
      var user = JSON.parse(localStorage.getItem("appGerenciaLogin"));
      var resUser1 = await api.listarRestaurantes();
      this.todosRestaurantes = Object.values(resUser1.resultado);

      // var periodo_meses = 0;
      // if (!localStorage.getItem("gerenciaPeriodoMeses")) {
      //   periodo_meses = this.periodo_meses;
      //   localStorage.setItem("gerenciaPeriodoMeses", periodo_meses);
      // } else {
      //   periodo_meses = localStorage.getItem("gerenciaPeriodoMeses");
      // }
      // this.periodo_meses = periodo_meses;

      const stored = sessionStorage.getItem("periodoCustomizado");

      if (stored) {
        this.periodoCustomizado = JSON.parse(stored);
        this.dateRange = [
          this.periodoCustomizado[0].data_inicio,
          this.periodoCustomizado[0].data_fim,
        ];
        this.filtragem = true;
      } else {
        // período padrão: últimos 12 meses
        const hoje = new Date();
        const fim = hoje.toISOString().split("T")[0];
        const inicio = new Date(hoje.setMonth(hoje.getMonth() - 12))
          .toISOString()
          .split("T")[0];
        this.filtragem = false;
        this.periodoCustomizado = [
          {
            data_inicio: inicio,
            data_fim: fim,
          },
        ];

        sessionStorage.setItem(
          "periodoCustomizado",
          JSON.stringify(this.periodoCustomizado)
        );
      }

      if (!localStorage.getItem("gerenciaTopEscolhido")) {
        this.topEscolhido = 5;
        // localStorage.setItem("gerenciaTopEscolhido", periodo_meses);
      } else {
        this.topEscolhido = localStorage.getItem("gerenciaTopEscolhido");
      }
      if (!localStorage.getItem("gerenciaRestauranteAtivo")) {
        localStorage.setItem("gerenciaRestauranteAtivo", "Todos");
      }
      this.restauranteEscolhido = localStorage.getItem(
        "gerenciaRestauranteAtivo"
      );
      this.restaurante = localStorage.getItem("gerenciaRestauranteAtivo")
        ? localStorage.getItem("gerenciaRestauranteAtivo")
        : "Todos";
      let resUser = await api.listarRestaurante({
        nome: localStorage.getItem("gerenciaRestauranteAtivo"),
      });
      var json = {
        restaurante: this.restaurante,
        periodo_meses: this.periodo_meses,
        data_inicio: this.periodoCustomizado[0].data_inicio,
        data_fim: this.periodoCustomizado[0].data_fim,
      };
      let consumo = await api.listarConsumoIntervalos(json);
      let cartoes = await api.buscarTodosCartoesCriados();
      var cartoes_array = Object.values(cartoes.resultado).sort(
        (a, b) => new Date(b.dt_created) - new Date(a.dt_created)
      );
      // return;
      consumo = Object.values(consumo.resultado);
      this.consumo = consumo;
      var clientes = {};
      let visitas = await api.listarVisitasIntervalos(json);
      visitas = visitas;
      consumo.forEach((item) => {
        const {
          NIF,
          qr_code,
          nome,
          email,
          telefone,
          categoria,
          produto,
          quantidade,
        } = item;
        const cartao = cartoes_array.find((c) => c.qr_code === qr_code);
        if (!clientes[qr_code]) {
          clientes[qr_code] = {
            nome: nome,
            NIF: NIF,
            qr_code: qr_code,
            sexo: cartao ? cartao.sexo : null,
            data_nascimento: cartao ? cartao.data_nascimento : null,
            telefone: telefone,
            email: email,
            bebidas: {},
            comidas: {},
            top_bebida: "",
            top_prato: "",
            max_bebida: 0,
            max_comida: 0,
            total_gasto: 0,
          };
        }

        // Filtra as visitas que correspondem ao NIF
        var temp = Object.values(visitas.detalheVisitas);
        var valorTotal = temp
          .filter((x) => x.qr_code === qr_code)
          .reduce((acc, curr) => acc + parseFloat(curr.valor), 0);
        const quant = parseInt(quantidade, 10);

        // Acumular quantidade para cada produto na respectiva categoria
        if (categoria === "BEBIDAS") {
          if (!clientes[qr_code].bebidas[produto]) {
            clientes[qr_code].bebidas[produto] = 0;
          }
          clientes[qr_code].bebidas[produto] += quant;

          // Atualizar o top produto de bebida
          if (
            clientes[qr_code].bebidas[produto] > clientes[qr_code].max_bebida
          ) {
            clientes[qr_code].max_bebida = clientes[qr_code].bebidas[produto];
            clientes[qr_code].top_bebida = produto;
          }
        }

        if (categoria === "COMIDA") {
          if (!clientes[qr_code].comidas[produto]) {
            clientes[qr_code].comidas[produto] = 0;
          }
          clientes[qr_code].comidas[produto] += quant;

          // Atualizar o top produto de comida
          if (
            clientes[qr_code].comidas[produto] > clientes[qr_code].max_comida
          ) {
            clientes[qr_code].max_comida = clientes[qr_code].comidas[produto];
            clientes[qr_code].top_prato = produto;
          }
        }

        clientes[qr_code].total_gasto = parseFloat(valorTotal);
      });
      // Obter o Top 3 clientes que mais gastaram
      let clientesArray = Object.values(clientes);
      clientesArray.sort(
        (a, b) => Number(b.total_gasto) - Number(a.total_gasto)
      );
      let topClientes = clientesArray.slice(0, this.topEscolhido);

      // Criar um objeto filtrado apenas com os Top 3 clientes
      let clientesTop = topClientes.reduce((acc, cliente) => {
        acc[cliente.qr_code] = cliente;
        return acc;
      }, {});

      // Agora você pode atualizar o objeto clientes com apenas os Top 3 clientes
      clientes = clientesTop;
      // Ou fazer o que precisar com o objeto `clientes` contendo ap

      const table = Object.values(clientes)
        .sort((a, b) => Number(b.total_gasto) - Number(a.total_gasto))
        .map((cliente) => ({
          nome: cliente.nome,
          NIF: cliente.NIF,
          qr_code: cliente.qr_code,
          sexo: cliente.sexo,
          data_nascimento: cliente.data_nascimento,
          telefone: cliente.telefone,
          email: cliente.email,
          top_bebida: cliente.top_bebida,
          top_prato: cliente.top_prato,
          total_gasto: cliente.total_gasto.toFixed(2),
        }));

      this.table = table;
      // VER O QUE FOI MAIS CONSUMIDO

      var comidas = {};
      var bebidas = {};
      consumo.forEach((item) => {
        if (item.categoria === "COMIDA") {
          if (comidas[item.produto]) {
            comidas[item.produto] += parseInt(item.quantidade);
          } else {
            comidas[item.produto] = parseInt(item.quantidade);
          }
        } else if (item.categoria === "BEBIDAS") {
          if (bebidas[item.produto]) {
            bebidas[item.produto] += parseInt(item.quantidade);
          } else {
            bebidas[item.produto] = parseInt(item.quantidade);
          }
        }
      });

      const bebidasCount = consumo.reduce((acc, curr) => {
        if (curr.categoria === "BEBIDAS") {
          if (!acc[curr.produto]) {
            acc[curr.produto] = 0;
          }
          acc[curr.produto] += parseInt(curr.quantidade, 10);
        }
        return acc;
      }, {});
      const pratosCount = consumo.reduce((acc, curr) => {
        if (curr.categoria === "COMIDA") {
          if (!acc[curr.produto]) {
            acc[curr.produto] = 0;
          }
          acc[curr.produto] += parseInt(curr.quantidade, 10);
        }
        return acc;
      }, {});

      const topBebidas = Object.entries(bebidasCount)
        .sort((a, b) => b[1] - a[1])
        .slice(0, 6);

      const topcomidas = Object.entries(pratosCount)
        .sort((a, b) => b[1] - a[1])
        .slice(0, 6);

      const labels = topBebidas.map((item) => item[0]);
      const dataValues = topBebidas.map((item) => item[1]);
      const labelsComidas = topcomidas.map((item) => item[0]);
      const dataValuesComidas = topcomidas.map((item) => item[1]);

      this.bebidasChart = {
        extraOptions: chartConfigs.barChartOptions,
        chartData: {
          labels: labels,
          datasets: [
            {
              label: "Quantidade",
              fill: true,
              borderColor: config.colors.info,
              borderWidth: 2,
              borderDash: [],
              borderDashOffset: 0.0,
              data: dataValues,
              backgroundColor: ["rgba(36,48,36, 0.2)"],
            },
          ],
        },
        gradientColors: config.colors.primaryGradient,
        gradientStops: [1, 0.4, 0],
      };

      this.pratosChart = {
        extraOptions: chartConfigs.barChartOptions,
        chartData: {
          labels: labelsComidas,
          datasets: [
            {
              label: "Quantidade",
              fill: true,
              borderColor: config.colors.info,
              borderWidth: 2,
              borderDash: [],
              borderDashOffset: 0.0,
              data: dataValuesComidas,
              backgroundColor: [
                "rgba(36,48,36, 0.2)",
                "rgba(36,48,36, 0.2)",
                "rgba(36,48,36, 0.2)",
                "rgba(36,48,36, 0.2)",
                "rgba(36,48,36, 0.2)",
                "rgba(36,48,36, 0.2)",
                "rgba(36,48,36, 0.2)",
                "rgba(36,48,36, 0.2)",
                "rgba(36,48,36, 0.2)",
              ],
            },
          ],
        },
        gradientColors: config.colors.primaryGradient,
        gradientStops: [1, 0.4, 0],
      };

      const comidaMaisComprada = this.findMostPurchased(comidas);
      const bebidaMaisComprada = this.findMostPurchased(bebidas);
      //Meter nos cards
      this.statsCards[0].title = bebidaMaisComprada.produto
        ? bebidaMaisComprada.produto +
          "<br><span class='quantidadeTitle'>" +
          bebidaMaisComprada.quantidade +
          " vendidas</span>"
        : "-----<br><span class='quantidadeTitle'> 0 vendidas</span>";
      this.statsCards[1].title = comidaMaisComprada.produto
        ? comidaMaisComprada.produto +
          "<br><span class='quantidadeTitle'>" +
          comidaMaisComprada.quantidade +
          " vendidas</span>"
        : "-----<br><span class='quantidadeTitle'> 0 vendidas</span>";
      this.statsCards[2].title = resUser.resultado.numero_visitas.toString();
      this.statsCards[3].title =
        Number(resUser.resultado.media_por_ticket).toFixed(2) + " €";

      const visitsPerMonth = {};
      Object.values(visitas.detalheVisitas).forEach((visit) => {
        const month = new Date(visit.data_visita)
          .toLocaleString("default", { month: "short" })
          .toUpperCase();
        if (!visitsPerMonth[month]) {
          visitsPerMonth[month] = 0;
        }
        visitsPerMonth[month]++;
      });

      const allMonths = [
        "JAN.",
        "FEV.",
        "MAR.",
        "ABR.",
        "MAI.",
        "JUN.",
        "JUL.",
        "AGO.",
        "SET.",
        "OUT.",
        "NOV.",
        "DEZ.",
      ];

      const labelsVisitas = allMonths.filter(
        (month) => visitsPerMonth[month] !== undefined
      );
      const dataValuesVisitas = labelsVisitas.map(
        (month) => visitsPerMonth[month]
      );

      this.visitasChart = {
        extraOptions: chartConfigs.purpleChartOptions,
        chartData: {
          labels: labelsVisitas,
          datasets: [
            {
              label: "Número de Visitas",
              fill: true,
              borderColor: config.colors.danger,
              borderWidth: 2,
              borderDash: [],
              borderDashOffset: 0.0,
              pointBackgroundColor: config.colors.danger,
              pointBorderColor: "rgba(255,255,255,0)",
              pointHoverBackgroundColor: config.colors.danger,
              pointBorderWidth: 20,
              pointHoverRadius: 4,
              pointHoverBorderWidth: 15,
              pointRadius: 4,
              data: dataValuesVisitas,
              backgroundColor: ["rgba(36,48,36, 0.2)"],
            },
          ],
        },
        gradientColors: [
          "rgba(66,134,121,0.15)",
          "rgba(66,134,121,0.0)",
          "rgba(66,134,121,0)",
        ],
        gradientStops: [1, 0.4, 0],
      };

      // GRAFICO FATURAÇÃO / MES

      const faturacaoPerMonthGrafico = {};
      Object.values(visitas.detalheVisitas).forEach((visit) => {
        const month = new Date(visit.data_visita)
          .toLocaleString("default", { month: "short" })
          .toUpperCase();

        // Converter o valor para um número (caso esteja como string)
        const valor = parseFloat(visit.valor);

        if (!faturacaoPerMonthGrafico[month]) {
          faturacaoPerMonthGrafico[month] = 0;
        }
        faturacaoPerMonthGrafico[month] += valor; // Somar o valor da visita ao total do mês
      });

      // Filtrar os meses que têm faturação
      const labelsFaturacao = allMonths.filter(
        (month) => faturacaoPerMonthGrafico[month] !== undefined
      );

      // Criar os valores de faturação por mês
      const dataValuesFaturacao = labelsFaturacao.map((month) =>
        faturacaoPerMonthGrafico[month].toFixed(2)
      );

      // Configuração do gráfico de faturação
      this.faturacaoLineChart = {
        extraOptions: chartConfigs.purpleChartOptions,
        chartData: {
          labels: labelsFaturacao,
          datasets: [
            {
              label: "Faturação por Mês",
              fill: true,
              borderColor: config.colors.danger, // Cor diferente para faturação
              borderWidth: 2,
              borderDash: [],
              borderDashOffset: 0.0,
              pointBackgroundColor: config.colors.danger,
              pointBorderColor: "rgba(255,255,255,0)",
              pointHoverBackgroundColor: config.colors.danger,
              pointBorderWidth: 20,
              pointHoverRadius: 4,
              pointHoverBorderWidth: 15,
              pointRadius: 4,
              data: dataValuesFaturacao,
              backgroundColor: ["rgba(36,48,36, 0.2)"],
            },
          ],
        },
        gradientColors: [
          "rgba(255, 99, 71, 0.5)",
          "rgba(255, 99, 71, 0.5)",
          "rgba(255, 99, 71, 0.5)",
        ],
        gradientStops: [1, 0.4, 0],
      };
      // FIM

      // GRÁFICO LINHAS VISITAS UNICAS

      // Obter o número de visitas únicas por mês
      const uniqueVisitsPerMonth = {};
      Object.values(visitas.detalheVisitas).forEach((visit) => {
        const month = new Date(visit.data_visita)
          .toLocaleString("default", { month: "short" })
          .toUpperCase();

        // Usar NIF como identificador único do cliente
        const nif = visit.nif;

        if (!uniqueVisitsPerMonth[month]) {
          uniqueVisitsPerMonth[month] = new Set(); // Usar Set para garantir unicidade
        }

        uniqueVisitsPerMonth[month].add(nif); // Adicionar o NIF ao Set do mês
      });

      // Transformar o Set em contagens de visitas únicas por mês
      const labelsUniqueVisitas = allMonths.filter(
        (month) => uniqueVisitsPerMonth[month] !== undefined
      );

      // Criar os valores de visitas únicas por mês
      const dataValuesUniqueVisitas = labelsUniqueVisitas.map(
        (month) => uniqueVisitsPerMonth[month].size // Obter o número de NIFs únicos
      );

      // Configuração do gráfico de visitas únicas
      this.visitasUnicasChart = {
        extraOptions: chartConfigs.purpleChartOptions,
        chartData: {
          labels: labelsUniqueVisitas,
          datasets: [
            {
              label: "Número de Visitas Únicas",
              fill: true,
              borderColor: config.colors.danger, // Cor diferente para visitas únicas
              borderWidth: 2,
              borderDash: [],
              borderDashOffset: 0.0,
              pointBackgroundColor: config.colors.danger,
              pointBorderColor: "rgba(255,255,255,0)",
              pointHoverBackgroundColor: config.colors.danger,
              pointBorderWidth: 20,
              pointHoverRadius: 4,
              pointHoverBorderWidth: 15,
              pointRadius: 4,
              data: dataValuesUniqueVisitas,
              backgroundColor: ["rgba(36,48,36, 0.2)"],
            },
          ],
        },
        gradientColors: [
          "rgba(66,134,121,0.15)",
          "rgba(66,134,121,0.0)",
          "rgba(66,134,121,0)",
        ],
        gradientStops: [1, 0.4, 0],
      };

      //FIM

      // GRAFICO Ticket Medio

      // Obter a faturação total e o número de visitas por mês
      const faturacaoPerMonth = {};
      const visitasPerMonth = {};

      Object.values(visitas.detalheVisitas).forEach((visit) => {
        const month = new Date(visit.data_visita)
          .toLocaleString("default", { month: "short" })
          .toUpperCase();

        const valor = parseFloat(visit.valor);

        if (!faturacaoPerMonth[month]) {
          faturacaoPerMonth[month] = 0;
          visitasPerMonth[month] = 0;
        }

        // Somar o valor da visita ao total de faturação do mês
        faturacaoPerMonth[month] += valor;
        // Contar o número de visitas (não únicas)
        visitasPerMonth[month]++;
      });

      // Calcular o ticket médio por mês
      const ticketMedioPerMonth = {};
      Object.keys(faturacaoPerMonth).forEach((month) => {
        ticketMedioPerMonth[month] =
          faturacaoPerMonth[month] / visitasPerMonth[month];
      });

      // Obter os meses com ticket médio calculado
      const labelsTicketMedio = allMonths.filter(
        (month) => ticketMedioPerMonth[month] !== undefined
      );

      // Criar os valores do ticket médio por mês
      const dataValuesTicketMedio = labelsTicketMedio.map((month) =>
        ticketMedioPerMonth[month].toFixed(2)
      );

      // Configuração do gráfico de ticket médio por mês
      this.ticketMedioChart = {
        extraOptions: chartConfigs.purpleChartOptions,
        chartData: {
          labels: labelsTicketMedio, // Meses com ticket médio
          datasets: [
            {
              label: "Ticket Médio por Mês",
              fill: true,
              borderColor: config.colors.info, // Cor do gráfico
              borderWidth: 2,
              borderDash: [],
              borderDashOffset: 0.0,
              pointBackgroundColor: config.colors.info,
              pointBorderColor: "rgba(255,255,255,0)",
              pointHoverBackgroundColor: config.colors.info,
              pointBorderWidth: 20,
              pointHoverRadius: 4,
              pointHoverBorderWidth: 15,
              pointRadius: 4,
              data: dataValuesTicketMedio,
              backgroundColor: ["rgba(36,48,36, 0.2)"],
            },
          ],
        },
        gradientColors: ["rgba(36,48,36, 0.2)"],
        gradientStops: [1, 0.4, 0],
      };
      //FIM
      this.statsCards[2].title = visitas.numero_visitas.toString();
      this.statsCards[3].title = Number(visitas.ticket_medio).toFixed(2) + " €";
      this.faturacao = Number(visitas.valor_total);
      var tempCards = this.statsCards;
      for (let i = 0; i < tempCards.length; i++) {
        tempCards[i].footer =
          "<strong>De " +
          this.formatDatePT(this.periodoCustomizado[0].data_inicio) +
          " a " +
          this.formatDatePT(this.periodoCustomizado[0].data_fim) +
          " </strong>";
      }
      this.statsCards = tempCards;

      var detalhes_visitas = Object.values(visitas.detalheVisitas);
      // Faturação total do detalhes_visitas
      const totalFaturacaoDetalhesVisitas = detalhes_visitas.reduce(
        (acc, visita) => acc + parseFloat(visita.valor),
        0
      );

      // Faturação total do topClientes
      const totalFaturacaoTopClientes = topClientes.reduce(
        (acc, cliente) => acc + cliente.total_gasto,
        0
      );

      // Número de visitas em detalhes_visitas
      const numeroVisitasDetalhesVisitas = detalhes_visitas.length;

      // Contagem de visitas dos clientes em topClientes com base no NIF em detalhes_visitas
      const numeroVisitasTopClientes = topClientes.reduce((acc, cliente) => {
        // Filtra quantas vezes o cliente foi encontrado no detalhes_visitas
        const visitasCliente = detalhes_visitas.filter(
          (visita) => visita.qr_code === cliente.qr_code
        ).length;
        return acc + visitasCliente;
      }, 0);

      // Arrays finais para gráficos
      const faturacaoTotal = [
        totalFaturacaoDetalhesVisitas,
        totalFaturacaoTopClientes,
      ];
      const numeroVisitas = [
        numeroVisitasDetalhesVisitas,
        numeroVisitasTopClientes,
      ];

      // Calcular o total de faturação
      const totalFaturacao = totalFaturacaoDetalhesVisitas;

      // Calcular a percentagem de faturação dos top clientes
      const topClientesPercent = (
        (totalFaturacaoTopClientes / totalFaturacao) *
        100
      ).toFixed(2);

      // Calcular o restante (parte vazia)
      const restantesPercent = (100 - topClientesPercent).toFixed(2);

      // Configuração da pie chart (apenas para topClientes)
      this.pieChart2.chartData = {
        labels: ["Top Clientes", "Restantes Clientes"],
        datasets: [
          {
            label: "Faturação Top Clientes",
            backgroundColor: ["#243024", "#E5E4E2"],
            borderWidth: 0,
            data: [topClientesPercent, restantesPercent],
          },
        ],
      };

      // Calcular o total de visitas (detalhes_visitas)
      const totalVisitas = numeroVisitasDetalhesVisitas;
      const topClientesVisitas =
        (numeroVisitasTopClientes / totalVisitas) * 100;
      const restantesVisitas = 100 - topClientesVisitas;

      const topClientesVisitasPercent = topClientesVisitas.toFixed(2);
      const restantesVisitasPercent = restantesVisitas.toFixed(2);

      this.pieChart3.chartData = {
        labels: ["Top Clientes", "Restantes Clientes"],
        datasets: [
          {
            label: "Visitas Top Clientes",
            backgroundColor: ["#243024", "#E5E4E2"],
            borderWidth: 0,
            data: [topClientesVisitasPercent, restantesVisitasPercent],
          },
        ],
      };

      this.rendered = true;
      return;
    },
    formatDatePT(dateString) {
      if (!dateString) return ""; // Retorna vazio se a data for inválida ou nula
      const [year, month, day] = dateString.split("-");
      return `${day}/${month}/${year}`;
    },
    findMostPurchased(items) {
      let mostPurchasedItem = null;
      let maxQuantity = 0;

      for (let item in items) {
        if (items[item] > maxQuantity) {
          mostPurchasedItem = item;
          maxQuantity = items[item];
        }
      }

      return { produto: mostPurchasedItem, quantidade: maxQuantity };
    },
  },
  async mounted() {
    await this.inicio();
    this.i18n = this.$i18n;
    if (this.enableRTL) {
      this.i18n.locale = "ar";
      this.$rtl.enableRTL();
    }
  },
  beforeDestroy() {
    if (this.$rtl.isRTL) {
      this.i18n.locale = "en";
      this.$rtl.disableRTL();
    }
  },
};
</script>
<style>
#worldMap .datamap {
  left: 0 !important;
}
</style>
